<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col-sm-7">
            <h5 class="card-title mb-0">Verpressungen</h5>
          </div>
          <div class="col-sm-5 text-right">
            <p-button
              v-if="canCreate"
              type="success"
              class="mt-0"
              title="Verpressung erfassen"
              @click="openCreateDialog"
            >
              <i class="bi bi-plus-circle mr-1"></i> Verpressung erfassen
            </p-button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <el-table
          :data="pressings"
          v-loading="loading"
          empty-text="Es wurden noch keine Verpressungen erfasst."
          header-row-class-name="text-primary"
          class="pressings-table"
          @row-click="openDetails"
        >
          <el-table-column
            prop="dateLabel"
            label="Datum"
            min-width="105"
            :filters="columnFilters.dateLabel"
            :filter-method="filterColumn"
            filter-placement="bottom-end"
          ></el-table-column>
          <el-table-column
            prop="performedByName"
            label="Durchgeführt von"
            min-width="170"
            :filters="columnFilters.performedByName"
            :filter-method="filterColumn"
            filter-placement="bottom-end"
          ></el-table-column>
          <el-table-column
            prop="locationName"
            label="Standort"
            min-width="120"
            :filters="columnFilters.locationName"
            :filter-method="filterColumn"
            filter-placement="bottom-end"
          ></el-table-column>
          <el-table-column
            prop="parcoursName"
            label="Parcours"
            min-width="140"
            :filters="columnFilters.parcoursName"
            :filter-method="filterColumn"
            filter-placement="bottom-end"
          ></el-table-column>
          <el-table-column
            prop="elementName"
            label="Element"
            min-width="160"
            :filters="columnFilters.elementName"
            :filter-method="filterColumn"
            filter-placement="bottom-end"
          ></el-table-column>
          <el-table-column
            prop="press"
            label="Presse"
            min-width="175"
            :filters="columnFilters.press"
            :filter-method="filterColumn"
            filter-placement="bottom-end"
          ></el-table-column>
          <el-table-column
            prop="ropeDiameter"
            label="Seil"
            min-width="125"
            :filters="columnFilters.ropeDiameter"
            :filter-method="filterColumn"
            filter-placement="bottom-end"
          ></el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      title="Verpressung erfassen"
      :visible.sync="createDialogVisible"
      width="760px"
      custom-class="pressing-dialog"
      :close-on-click-modal="false"
      @closed="resetForm"
    >
      <el-alert
        v-if="formError"
        :title="formError"
        type="error"
        show-icon
        :closable="false"
        class="mb-3"
      ></el-alert>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Datum *</label>
          <input v-model="form.date" type="date" class="form-control" :max="today" />
        </div>
        <div class="col-md-6 form-group">
          <label>Durchgeführt von *</label>
          <el-select v-model="form.performedById" filterable placeholder="Benutzer wählen" class="w-100">
            <el-option
              v-for="user in constructionUsers"
              :key="user.uid"
              :label="user.name"
              :value="user.uid"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 form-group">
          <label>Standort *</label>
          <el-select v-model="form.locationId" placeholder="Standort wählen" class="w-100" @change="loadParcours">
            <el-option v-for="location in locations" :key="location.key" :label="location.name" :value="location.key"></el-option>
          </el-select>
        </div>
        <div class="col-md-4 form-group">
          <label>Parcours *</label>
          <el-select
            v-model="form.parcoursId"
            filterable
            placeholder="Parcours wählen"
            class="w-100"
            :disabled="!form.locationId || loadingParcours"
            @change="loadElements"
          >
            <el-option v-for="parcoursItem in parcours" :key="parcoursItem.id" :label="parcoursItem.name" :value="parcoursItem.id"></el-option>
          </el-select>
        </div>
        <div class="col-md-4 form-group">
          <label>Element *</label>
          <el-select
            v-model="form.elementId"
            filterable
            placeholder="Element wählen"
            class="w-100"
            :disabled="!form.parcoursId || loadingElements"
          >
            <el-option v-for="element in elements" :key="element.id" :label="element.name" :value="element.id"></el-option>
          </el-select>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Presse *</label>
          <el-select v-model="form.press" placeholder="Presse wählen" class="w-100">
            <el-option label="Presse 1 (Darmstadt)" value="Presse 1 (Darmstadt)"></el-option>
            <el-option label="Presse 2 (Neroberg)" value="Presse 2 (Neroberg)"></el-option>
          </el-select>
        </div>
        <div class="col-md-6 form-group">
          <label>Seildurchmesser *</label>
          <el-select v-model="form.ropeDiameter" placeholder="Seildurchmesser wählen" class="w-100">
            <el-option label="12mm verdichtet" value="12mm verdichtet"></el-option>
            <el-option label="10mm" value="10mm"></el-option>
          </el-select>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-group">
          <label>Seilart *</label>
          <div class="choice-group">
            <el-radio v-model="form.ropeType" label="Sicherungsseil">Sicherungsseil</el-radio>
            <el-radio v-model="form.ropeType" label="Elementseil">Elementseil</el-radio>
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label>Stoßverpressung *</label>
          <div class="choice-group">
            <el-radio v-model="form.buttPressing" :label="true">Ja</el-radio>
            <el-radio v-model="form.buttPressing" :label="false">Nein</el-radio>
          </div>
        </div>
        <div class="col-md-3">
          <label>Anzahl *</label>
          <el-input-number
            v-model="form.pressingCount"
            :min="1"
            :max="5"
            :step="1"
            class="w-100"
          ></el-input-number>
        </div>
      </div>

      <div class="form-group">
        <label>Fotos <span class="optional-label">optional, maximal 5</span></label>
        <div class="photo-actions">
          <p-button type="default" size="sm" :disabled="form.photos.length >= 5" @click="$refs.photoInput.click()">
            <i class="bi bi-image mr-1"></i> Foto auswählen
          </p-button>
          <input ref="photoInput" type="file" accept="image/*" multiple class="d-none" @change="addPhotos" />
        </div>
        <div v-if="form.photos.length" class="photo-grid mt-2">
          <div v-for="(photo, index) in form.photos" :key="photo.preview" class="photo-preview">
            <img :src="photo.preview" :alt="'Foto ' + (index + 1)" />
            <button type="button" title="Foto entfernen" @click="removePhoto(index)">
              <i class="bi bi-x"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="form-group mb-0">
        <label>Anmerkungen <span class="optional-label">optional</span></label>
        <textarea v-model.trim="form.notes" class="form-control px-2" rows="3" placeholder="Zusätzliche Hinweise"></textarea>
      </div>

      <span slot="footer" class="dialog-footer">
        <p-button type="default" link :disabled="saving" @click="createDialogVisible = false">Abbrechen</p-button>
        <p-button type="success" :disabled="saving" @click="savePressing">
          <i v-if="saving" class="el-icon-loading mr-1"></i>{{ saving ? 'Wird gespeichert' : 'Speichern' }}
        </p-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Details der Verpressung"
      :visible.sync="detailDialogVisible"
      width="760px"
      custom-class="pressing-dialog"
    >
      <div v-if="selectedPressing" class="pressing-details">
        <div class="detail-grid">
          <div class="detail-item"><span>Datum</span><strong>{{ selectedPressing.dateLabel }}</strong></div>
          <div class="detail-item"><span>Durchgeführt von</span><strong>{{ selectedPressing.performedByName }}</strong></div>
          <div class="detail-item"><span>Standort</span><strong>{{ selectedPressing.locationName }}</strong></div>
          <div class="detail-item"><span>Parcours</span><strong>{{ selectedPressing.parcoursName }}</strong></div>
          <div class="detail-item"><span>Element</span><strong>{{ selectedPressing.elementName }}</strong></div>
          <div class="detail-item"><span>Presse</span><strong>{{ selectedPressing.press }}</strong></div>
          <div class="detail-item"><span>Seildurchmesser</span><strong>{{ selectedPressing.ropeDiameter }}</strong></div>
          <div class="detail-item"><span>Seilart</span><strong>{{ selectedPressing.ropeType }}</strong></div>
          <div class="detail-item"><span>Stoßverpressung</span><strong>{{ selectedPressing.buttPressing ? 'Ja' : 'Nein' }}</strong></div>
          <div class="detail-item"><span>Anzahl der Verpressungen</span><strong>{{ selectedPressing.pressingCount }}</strong></div>
        </div>
        <div class="detail-notes mt-3">
          <span>Anmerkungen</span>
          <p>{{ selectedPressing.notes || 'Keine Anmerkungen hinterlegt' }}</p>
        </div>
        <div class="mt-4">
          <h6>Fotos</h6>
          <div v-if="selectedPressing.photos.length" class="detail-photo-grid">
            <a v-for="(photo, index) in selectedPressing.photos" :key="photo.url || photo" :href="photo.url || photo" target="_blank" rel="noopener noreferrer">
              <img :src="photo.url || photo" :alt="'Foto ' + (index + 1)" />
            </a>
          </div>
          <p v-else class="text-muted mb-0">Keine Fotos hinterlegt</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase/compat/app";
import { httpsCallable } from "firebase/functions";
import {
  Alert,
  Dialog,
  InputNumber,
  Loading,
  MessageBox,
  Option,
  Radio,
  Select,
  Table,
  TableColumn,
} from "element-ui";
import { db, fc, FirebaseStorage } from "../../../../firebaseDb";
import locationsStore from "../../../../locationStore";
import router from "../../../../main";
import store from "../../../../store";

Vue.use(Alert);
Vue.use(Dialog);

Vue.use(Loading);
Vue.use(Radio);
Vue.use(Select);
Vue.use(Table);
Vue.use(TableColumn);

const currentLocalDate = () => {
  const now = new Date();
  return new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

const emptyForm = () => ({
  date: currentLocalDate(),
  performedById: "",
  locationId: store.getters.userlocation || "",
  parcoursId: "",
  elementId: "",
  press: "",
  ropeDiameter: "",
  ropeType: "",
  buttPressing: null,
  pressingCount: 1,
  notes: "",
  photos: [],
});

export default {
  components: {
    [Alert.name]: Alert,
    [Dialog.name]: Dialog,
    [InputNumber.name]: InputNumber,
    [Option.name]: Option,
    [Radio.name]: Radio,
    [Select.name]: Select,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      loading: true,
      saving: false,
      loadingParcours: false,
      loadingElements: false,
      createDialogVisible: false,
      detailDialogVisible: false,
      formError: "",
      pressings: [],
      constructionUsers: [],
      locations: locationsStore.getters.locations.locations,
      parcours: [],
      elements: [],
      selectedPressing: null,
      form: emptyForm(),
      unsubscribe: null,
      constructionRole: store.getters.constructionRole,
    };
  },
  computed: {
    canCreate() {
      return Number(this.constructionRole) === 4;
    },
    columnFilters() {
      const createFilters = (property) => [...new Set(this.pressings.map((pressing) => pressing[property]))]
        .filter((value) => value !== undefined && value !== null && value !== "")
        .sort((left, right) => String(left).localeCompare(String(right), "de"))
        .map((value) => ({ text: String(value), value }));

      return {
        dateLabel: createFilters("dateLabel"),
        performedByName: createFilters("performedByName"),
        locationName: createFilters("locationName"),
        parcoursName: createFilters("parcoursName"),
        elementName: createFilters("elementName"),
        press: createFilters("press"),
        ropeDiameter: createFilters("ropeDiameter"),
      };
    },
    today() {
      return currentLocalDate();
    },
  },
  created() {
    if (Number(store.getters.constructionRole) === 0) {
      MessageBox.alert("Zugriff verweigert.", {
        confirmButtonText: "OK",
        type: "error",
        callback: () => router.push({ name: "Overview" }),
      });
      return;
    }
    this.loadPressings();
    if (this.canCreate) {
      this.loadConstructionUsers();
    }
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
    this.revokePhotoPreviews();
  },
  methods: {
    filterColumn(value, row, column) {
      return row[column.property] === value;
    },
    loadPressings() {
      this.unsubscribe = db.collection("constructionPressings").orderBy("Date", "desc").onSnapshot(
        (snapshot) => {
          this.pressings = snapshot.docs.map((doc) => {
            const data = doc.data();
            const date = data.Date && data.Date.toDate ? data.Date.toDate() : new Date(data.Date);
            return {
              id: doc.id,
              dateLabel: Number.isNaN(date.getTime()) ? "-" : date.toLocaleDateString("de-DE"),
              performedByName: data.PerformedByName || "-",
              locationName: data.LocationName || data.LocationId || "-",
              parcoursName: data.ParcoursName || "-",
              elementName: data.ElementName || "-",
              press: data.Press || "-",
              ropeDiameter: data.RopeDiameter || "-",
              ropeType: data.RopeType || "-",
              buttPressing: data.ButtPressing === true,
              pressingCount: data.PressingCount || 1,
              notes: data.Notes || "",
              photos: Array.isArray(data.Photos) ? data.Photos : [],
            };
          });
          this.loading = false;
        },
        (error) => {
          console.error("Verpressungen konnten nicht geladen werden:", error);
          this.loading = false;
          MessageBox.alert("Die Verpressungen konnten nicht geladen werden.", { type: "error" });
        }
      );
    },
    async loadConstructionUsers() {
      try {
        const listUsers = httpsCallable(fc, "users-listUsers");
        const result = await listUsers([]);
        this.constructionUsers = (result.data.users || [])
          .filter((user) => user.customClaims && Number(user.customClaims.constructionRole) === 4 && !user.disabled)
          .map((user) => ({ uid: user.uid, name: user.displayName || user.email }))
          .sort((left, right) => left.name.localeCompare(right.name, "de"));
      } catch (error) {
        console.error("Bau-Benutzer konnten nicht geladen werden:", error);
        MessageBox.alert("Die Benutzer mit Vollzugriff Bau konnten nicht geladen werden.", { type: "error" });
      }
    },
    openCreateDialog() {
      if (!this.canCreate) return;
      this.createDialogVisible = true;
      if (this.form.locationId) this.loadParcours();
    },
    openDetails(row) {
      this.selectedPressing = row;
      this.detailDialogVisible = true;
    },
    async loadParcours() {
      this.form.parcoursId = "";
      this.form.elementId = "";
      this.parcours = [];
      this.elements = [];
      if (!this.form.locationId) return;
      this.loadingParcours = true;
      try {
        const snapshot = await db.collection("parcours").where("locationID", "==", this.form.locationId).get();
        this.parcours = snapshot.docs
          .map((doc) => ({ id: doc.id, name: doc.data().Name, position: doc.data().position || doc.data().Position || 0 }))
          .sort((left, right) => left.position - right.position || left.name.localeCompare(right.name, "de"));
      } catch (error) {
        console.error("Parcours konnten nicht geladen werden:", error);
        MessageBox.alert("Die Parcours konnten nicht geladen werden.", { type: "error" });
      } finally {
        this.loadingParcours = false;
      }
    },
    async loadElements() {
      this.form.elementId = "";
      this.elements = [];
      if (!this.form.parcoursId) return;
      this.loadingElements = true;
      try {
        const snapshot = await db.collection("parcours").doc(this.form.parcoursId).collection("elements").get();
        this.elements = snapshot.docs
          .map((doc) => ({ id: doc.id, name: doc.data().elementName, position: doc.data().elementPosition || 0 }))
          .sort((left, right) => left.position - right.position || left.name.localeCompare(right.name, "de"));
      } catch (error) {
        console.error("Elemente konnten nicht geladen werden:", error);
        MessageBox.alert("Die Elemente konnten nicht geladen werden.", { type: "error" });
      } finally {
        this.loadingElements = false;
      }
    },
    addPhotos(event) {
      const files = Array.from(event.target.files || []);
      const remaining = 5 - this.form.photos.length;
      const imageFiles = files.filter((file) => file.type.startsWith("image/")).slice(0, remaining);
      imageFiles.forEach((file) => this.form.photos.push({ file, preview: URL.createObjectURL(file) }));
      event.target.value = "";
      if (files.length > remaining) {
        MessageBox.alert("Es können maximal 5 Fotos hinterlegt werden.", { type: "warning" });
      }
    },
    removePhoto(index) {
      URL.revokeObjectURL(this.form.photos[index].preview);
      this.form.photos.splice(index, 1);
    },
    revokePhotoPreviews() {
      this.form.photos.forEach((photo) => URL.revokeObjectURL(photo.preview));
    },
    validateForm() {
      const required = [
        this.form.date,
        this.form.performedById,
        this.form.locationId,
        this.form.parcoursId,
        this.form.elementId,
        this.form.press,
        this.form.ropeDiameter,
        this.form.ropeType,
      ];
      if (required.some((value) => !value) || this.form.buttPressing === null) {
        return "Bitte alle Pflichtfelder ausfüllen.";
      }
      if (this.form.date > this.today) return "Das Datum darf nicht in der Zukunft liegen.";
      if (!Number.isInteger(this.form.pressingCount) || this.form.pressingCount < 1 || this.form.pressingCount > 5) {
        return "Die Anzahl der Verpressungen muss zwischen 1 und 5 liegen.";
      }
      if (this.form.photos.length > 5) return "Es können maximal 5 Fotos hinterlegt werden.";
      return "";
    },
    async savePressing() {
      this.formError = this.validateForm();
      if (this.formError || this.saving || !this.canCreate) return;

      const user = this.constructionUsers.find((item) => item.uid === this.form.performedById);
      const location = this.locations.find((item) => item.key === this.form.locationId);
      const parcoursItem = this.parcours.find((item) => item.id === this.form.parcoursId);
      const element = this.elements.find((item) => item.id === this.form.elementId);
      if (!user || !location || !parcoursItem || !element) {
        this.formError = "Die ausgewählten Stammdaten sind nicht mehr verfügbar. Bitte wählen Sie sie erneut aus.";
        return;
      }

      this.saving = true;
      const docRef = db.collection("constructionPressings").doc();
      const uploadedPhotos = [];
      try {
        for (let index = 0; index < this.form.photos.length; index += 1) {
          const photo = this.form.photos[index];
          const extension = (photo.file.name.split(".").pop() || "jpg").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
          const path = `verpressungen/${docRef.id}/${index + 1}_${Date.now()}.${extension}`;
          const snapshot = await FirebaseStorage.ref(path).put(photo.file);
          const url = await snapshot.ref.getDownloadURL();
          uploadedPhotos.push({ url, path, name: photo.file.name });
        }

        const date = new Date(`${this.form.date}T00:00:00`);
        await docRef.set({
          Date: firebase.firestore.Timestamp.fromDate(date),
          PerformedById: user.uid,
          PerformedByName: user.name,
          LocationId: location.key,
          LocationName: location.name,
          ParcoursId: parcoursItem.id,
          ParcoursName: parcoursItem.name,
          ElementId: element.id,
          ElementName: element.name,
          Press: this.form.press,
          RopeDiameter: this.form.ropeDiameter,
          RopeType: this.form.ropeType,
          ButtPressing: this.form.buttPressing,
          PressingCount: this.form.pressingCount,
          Notes: this.form.notes,
          Photos: uploadedPhotos,
          CreatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          CreatedById: store.getters.user.data.uid,
          CreatedByName: store.getters.user.data.displayName || store.getters.user.data.email || "-",
        });

        this.createDialogVisible = false;
        MessageBox.alert("Die Verpressung wurde erfolgreich gespeichert.", { type: "success" });
      } catch (error) {
        console.error("Verpressung konnte nicht gespeichert werden:", error);
        await Promise.all(uploadedPhotos.map((photo) => FirebaseStorage.ref(photo.path).delete().catch(() => null)));
        this.formError = "Die Verpressung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.";
      } finally {
        this.saving = false;
      }
    },
    resetForm() {
      this.revokePhotoPreviews();
      this.form = emptyForm();
      this.formError = "";
      this.parcours = [];
      this.elements = [];
    },
  },
};
</script>

<style scoped>
.pressings-table { cursor: pointer; }
.choice-group { min-height: 40px; display: flex; align-items: center; flex-wrap: wrap; gap: 12px; }
.optional-label { color: #8b8b8b; font-size: 12px; font-weight: 400; }
.photo-actions { display: flex; gap: 8px; }
.photo-grid, .detail-photo-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); gap: 10px; }
.photo-preview { position: relative; aspect-ratio: 4 / 3; overflow: hidden; border: 1px solid #e5e5e5; border-radius: 4px; }
.photo-preview img, .detail-photo-grid img { width: 100%; height: 100%; object-fit: cover; }
.photo-preview button { position: absolute; top: 5px; right: 5px; width: 28px; height: 28px; border: 0; border-radius: 50%; background: rgba(31, 31, 31, .8); color: #fff; cursor: pointer; }
.detail-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1px; background: #e8e8e8; border: 1px solid #e8e8e8; }
.detail-item { background: #fff; padding: 12px 14px; }
.detail-item span, .detail-notes span { display: block; color: #777; font-size: 12px; margin-bottom: 3px; }
.detail-item strong { display: block; font-weight: 600; overflow-wrap: anywhere; }
.detail-notes { padding: 12px 14px; border: 1px solid #e8e8e8; }
.detail-notes p { margin: 0; white-space: pre-wrap; }
.detail-photo-grid a { display: block; aspect-ratio: 4 / 3; overflow: hidden; border-radius: 4px; border: 1px solid #e5e5e5; }
@media (max-width: 767px) {
  .detail-grid { grid-template-columns: 1fr; }
  .card-header .text-right { text-align: left !important; margin-top: 12px; }
}
</style>

<style>
.pressing-dialog .el-input:not(.is-disabled) .el-input__inner,
.pressing-dialog .el-textarea__inner,
.pressing-dialog .form-control {
  background-color: #fff;
  color: #606266;
}
.pressing-dialog .el-input:not(.is-disabled) .el-input__inner:focus,
.pressing-dialog .el-textarea__inner:focus,
.pressing-dialog .form-control:focus {
  border-color: #20a84a;
  box-shadow: 0 0 0 1px rgba(32, 168, 74, .15);
}
@media (max-width: 767px) {
  .pressing-dialog { width: calc(100% - 24px) !important; margin-top: 12px !important; }
  .pressing-dialog .el-dialog__body { padding: 15px; }
}
</style>